// convenient debug for DEV
const isDebugMode = process.env.VUE_APP_ENV !== 'production'

// 跨域代理前缀
const API_PROXY_PREFIX = '/api'
const BASE_URL =
  process.env.VUE_APP_ENV === 'development'
    ? API_PROXY_PREFIX
    : process.env.VUE_APP_API_BASE_URL

module.exports = {
  isDebugMode,
  API_PROXY_PREFIX,
  BASE_URL
}
